import React from "react";
import { Link } from "react-router-dom";
import { generateSlug } from "../../Pages/utils";
import "./ExameCategoryCard.css";

import { ReactComponent as Exames } from "../Assets/labexam.svg";

const ExameCategoryCard = ({ category, exams }) => {
  const MAX_EXAMS_TO_SHOW = 5;

  const sortedAndFilteredExams = exams
    .sort((a, b) => a.old_price - b.old_price)
    .slice(0, MAX_EXAMS_TO_SHOW);

  const allExamsLink = `/Lista-de-exames`;

  return (
    <div className="category-card">
      <div className="category-card__header">
        <Exames className="icon-cardsss" />
        <h2 className="category-card__title">{category}</h2>
      </div>

      <div className="category-card__exam-list">
        {sortedAndFilteredExams.length > 0 ? (
          sortedAndFilteredExams.map((exam) => (
            <Link
              to={`/Lista-de-exames/${generateSlug(exam.name)}`}
              key={exam.id}
              className="exam-link"
            >
              <div className="exam-link__content">
                <span className="exam-link__name">{exam.name}</span>
                {exam.old_price && parseFloat(exam.old_price) > 0 && (
                  <span className="exam-link__price">
                    R$ {parseFloat(exam.old_price).toFixed(2).replace('.', ',')}
                  </span>
                )}
              </div>
            </Link>
          ))
        ) : (
          <p className="category-card__no-exams">Sem exames desse tipo.</p>
        )}
      </div>

      <div className="category-card__footer">
        <Link to={allExamsLink} className="category-card__see-all">
          VER TODOS OS EXAMES
        </Link>
      </div>
    </div>
  );
};

export default ExameCategoryCard;
